import React from "react";
import _ from "lodash";
import clsx from "clsx";

import { withStyles } from "@material-ui/core/styles";

import styles from "./styles";
import {isRequiredQuestion, isValidValue} from "../../../../../utils";
import SliderFormElement from "../../formElement/SliderFormElement";
import SliderFormElementV2 from "../../formElement/SliderFormElementV2";
import QuestionLabel from "../../formElement/QuestionLabel";

function isSliderQuestionValid(question, step, afterChange, service) {
  return isRequiredQuestion(question) ? isValidValue(question.answer) : true;
}

export const SliderQuestionMethods = {
  required: isRequiredQuestion,
  valid: isSliderQuestionValid
};

const SliderQuestion = props => {
  const {
    classes,
    question,
    onAnswerChange,
    dataService,
  } = props;

  const options = question.config.choices || [];
  const isRequired = SliderQuestionMethods.required(question);
  const step = 100 / (options.length - 1);

  const marks = options.map((option, index) => {
    return {
      value: 100 / (options.length - 1) * index,
      label: option.text,
      uid: option.uid,
      info: option.info,
      extra: option.extra,
    }
  });

  const getAnswer = (value) => {
    return marks && marks.find(item => item.value === value);
  };

  const getMark = (uid) => {
    return uid && marks && marks.find(item => item.uid === uid);
  };

  const defaultMark = isRequired ? marks[0] : {};
  const currMark = getMark(question.answer) || defaultMark;

  const handleChange = (newValue) => {
    onAnswerChange(question.uid, (getAnswer(newValue) || defaultMark).uid);
  };

  React.useEffect(() => {
    if (isRequired && !question.answer) {
      onAnswerChange(question.uid, defaultMark.uid);
    }
  }, []);

  const isNewDesign = dataService.isNewDesign;
  const SliderElement = React.useMemo(() => {
    return dataService.isNewDesign ? SliderFormElementV2 : SliderFormElement
  }, [isNewDesign]);

  return (
    <>
      {isNewDesign && question.question_text && (
        <QuestionLabel label={question.question_text} required={isRequired || question.required_check} />
      )}
      <div className={clsx(classes.sliderContainer, isNewDesign && 'newDesign')}>
        <SliderElement
          value={currMark.value}
          label={currMark.extra || currMark.label}
          step={step}
          marks={marks}
          onChange={handleChange}
        />
        {_.isString(currMark.info) && (
          <div className={clsx(classes.sliderHelpText, isNewDesign && 'newDesign')}>
            {currMark.info}
          </div>
        )}
      </div>
    </>
  )
};

export default withStyles(styles)(SliderQuestion);